import moment from "moment";
import React, { Component } from "react";
import { timezones } from "../utils/variables";
import Field from './Field';

class SeminarFields extends Component {

  render() {
    const { seminar } = this.props

    return (
      seminar ? (<React.Fragment>
        <Field label='Seminar' value={<a href={`/m1/seminars/${seminar.id}/registrations/all`}>{seminar.location}</a>} />
        <Field label='Seminar Address' value={seminar.address} />
        <Field label='Seminar Time' value={moment(seminar.at).tz(timezones[seminar.region || 'VIC']).format("MMM Do YYYY h:mm a")} />

      </React.Fragment>) : null
    )
  }
}

export default SeminarFields